import axios from 'axios'
import debounce from 'lodash.debounce'

export default {
  name: 'IncrementalSearch',
  props: [
    'attributeName',
    'attributeId',
    'initialText',
    'placeholder',
    'hideHistory',
    'queryText',
  ],
  data() {
    return {
      keyword: this.initialText,
      companies: null,
      isListOpened: false,
      isHistoryOpened: false,
      isHideHistory: this.hideHistory || false,
      isWatched: true,
      listStyle: { width: 0 },
      suggestionQuery: this.queryText || '',
      arrowCounter: -1,
      isArrowKey: false,
    }
  },
  watch: {
    keyword() {
      // lodash.debounceを利用してAPI呼び出しの負荷軽減
      if (this.isWatched && !this.isArrowKey) {
        this.debouncedGetList()
      }
    },
  },
  created() {
    // lodash.debounce によって、1秒間操作が無くなった時点でAPI呼び出し実施
    // キー入力の度にAPIを呼び出すような負荷をかけないため
    this.debouncedGetList = debounce(this.getList, 200)
    // if(this.attributeValue) this.keyword = this.attributeValue
  },
  mounted() {
    window.addEventListener('resize', this.isSP)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.isSP)
  },
  methods: {
    isSP() {
      return window.matchMedia('(max-width: 767px)').matches
    },
    focus(e) {
      if (this.isSP()) {
        window.scrollTo({
          top:
            e.currentTarget.getBoundingClientRect().top +
            window.pageYOffset -
            20,
          behavior: 'smooth',
        })
      }

      this.listStyle.width = this.$root.$el.clientWidth + 'px'

      if (!this.isHideHistory) {
        axios.get('/toushi/companies/suggestions/histories').then(response => {
          this.companies = response.data.companies
          if (this.companies.length) {
            this.isListOpened = true
            this.isHistoryOpened = true
          }
        })
      }
    },
    getList() {
      this.isHistoryOpened = false

      // キーワードが空の場合はメッセージと検索結果を空にして処理終了
      if (this.keyword === '') {
        this.companies = null
        this.isListOpened = false
        return
      }

      axios
        .get(this.suggestionsApiEndpoint())
        .then(response => {
          this.companies = response.data.companies
          this.isListOpened = this.companies.length ? true : false
        })
        .catch(() => {})
    },
    suggestionsApiEndpoint() {
      const query = `?phrase=${this.keyword}${
        this.suggestionQuery != '' ? '&' + this.suggestionQuery : ''
      }`
      return encodeURI(`/toushi/companies/suggestions${query}`)
    },
    blur() {
      setTimeout(() => {
        this.isListOpened = false
        if (!this.isSP()) {
          this.arrowCounter = -1
        }
      }, 200)
    },
    click(e) {
      this.keyword = e.currentTarget.textContent
      this.isWatched = false
    },
    input() {
      if (!this.isSP()) {
        this.isArrowKey = false
        this.arrowCounter = -1
      }
    },
    arrowDown() {
      if (!this.isSP() && this.arrowCounter < this.companies.length - 1) {
        this.arrowCounter = this.arrowCounter + 1
        this.keyword = this.companies[this.arrowCounter].name
        this.isArrowKey = true
      }
    },
    arrowUp() {
      if (!this.isSP() && this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
        this.keyword = this.companies[this.arrowCounter].name
        this.isArrowKey = true
      }
    },
  },
}
